(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image_text_slider"] && !Shopify.designMode) return;
  try {
    
  var flkty = new Flickity( '.index_hero_banner .image_with_text_slide_items', {
    // options
    pageDots: true,
    contain: true,
    wrapAround: true,
    prevNextButtons: false
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    

var flkty = new Flickity( '.reviews .review_items', {
  cellAlign: 'left',
  pageDots: true,
  prevNextButtons: true,
  wrapAround: true,
  contain: true,
});

  

  } catch(e) { console.error(e); }
})();
})();
